export const messages = [
  "Oops! It seems like your internet is taking a break. Go grab a coffee!",
  "Hey! Did your internet just leave without saying goodbye? How rude!",
  "Yikes! It looks like your internet is lost in space. Maybe it's hanging out with the Mars Rover?",
  "Your internet connection is like a ninja; it's there one second and gone the next!",
  "Looks like your internet went on vacation. Can we come too?",
  "Internet not found. Have you tried turning it off and on again?",
  "Knock knock! Who's there? Not your internet connection!",
  "No internet connection? Looks like you're gonna have to go outside and talk to real people. Good luck!",
  "Your internet connection is lost. Here's a duck to quack you up in the meantime.",
  "Can't connect to the internet? At least you won't have to deal with all those pesky notifications for a while!",
  "Oh no! Your internet's out! Here's a koala to remind you that taking a nap is always an option.",
  "Looks like you're offline. Here's a llama to remind you that sometimes, it's good to just take it slow and chill.",
  "No internet? No problem! Here's a sloth to remind you that it's okay to take a break every now and then.",
  "Internet's down? Don't worry, this dinosaur will keep you company until it's back up!",
  "Looks like you're disconnected. Here's a squirrel to remind you that there's a whole world outside your screen.",
];

export const images = [
  `
  ( ͡° ͜ʖ ͡°)
  `,
  `
   ̿ ̿ ̿'̿'\\̵͇̿̿\\з=(•_•)=ε/̵͇̿̿/'̿'̿ ̿
  `,
  `
  ಠ_ಠ
  `,
  `
  ┬─┬ノ( º _ ºノ)
  `,
  `
  (╯°□°）╯︵ ┻━┻
  `,
  `
  (づ｡◕‿‿◕｡)づ
  `,
  `
   ┌─┐
   ┴─┴
  ɷ◡ಠ
  `,
  "    /\\_/\\\n   / o o \\\n  /   ^   \\\n /  _____  \\\n/____|____\\|\n\nLooks like your internet connection went down. Here's a cat to keep you company. Meow!",
  // ASCII art 2
  "   ,#####,\n   #_   _#\n   |a` `a|\n   |  u  |\n   \\  =  /\n   |\\___/|\n  /  \\_/  \\\n\nOh no! Your internet connection is lost. How about a robot to help fix things?",
  // ASCII art 3
  "   /\\_/\\\n  / o o \\\n (   \"   )\n  \\~(*)~/\n   | ^ |\n  / ^ \\\n\nNo internet connection? Don't worry, here's a cute bunny to keep you company.",
  // ASCII art 4
  "  ____\n / ___| _ __   __ _  ___ _ __\n \\___ \\| '_ \\ / _` |/ _ \\ '__|\n  ___) | |_) | (_| |  __/ |\n |____/| .__/ \\__,_|\\___|_|\n       |_|\n\nOops! Looks like your internet is down. Here's a fancy text to make up for it.",
  // ASCII art 5
  "  .----.\n /      \\\n|  O  O |\n| ' _'  |\n|   `   |\n \\_____/ \n\nYou're offline! Here's a friendly snail to remind you to slow down and relax.",
  // ASCII art 6
  "   .-\"-.    \n  /[] _ _\\   \n _|_o_LII|_ \n/_  ,____\\ \n  ||  ||  \n\nLost your internet connection? Don't worry, this little guy will guide you through it.",
  // ASCII art 7
  "  ,#####,\n(-.___.-)\n(   \"   )\n \\~(*)~/\n  |^ ^|  \n >\\_\\/< \n\nLooks like the internet is out. Here's a penguin to help you chill and wait it out.",
  // ASCII art 8
  "   ,---.\n  / / \\ \\\n  ||   || \n  \\_\\ /_/ \n    `\"`\n\nNo internet? No problem! Here's a simple smiley face to brighten up your day.",
  // ASCII art 9
  "   ,~.\n  / oo\\_____/|\n (   )       `|\n  \\_/|  |______|\n     \\ -|     |\n     || |     |\n     || |     |\n\nSorry, you're offline. How about a cool dragon to keep you company while you wait for your connection to come back?",
  // Add more ASCII art here
];
